'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPlane = function TiPlane(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 22.5l-10-5.7v-9.9c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v9.9l-10 5.7c-0.7 0.4-1 1.3-0.7 2.1 0.4 0.8 1.2 1.2 2 1l8.7-2.5v7.4l-2.7 2.2c-0.6 0.5-0.8 1.4-0.4 2.1s1.3 1 2.1 0.7l3.5-1.4 3.6 1.4c0.2 0.1 0.4 0.1 0.6 0.1 0.6 0 1.1-0.3 1.4-0.8 0.5-0.7 0.3-1.6-0.4-2.1l-2.7-2.2v-7.4l8.7 2.5c0.2 0 0.4 0 0.5 0 0.7 0 1.3-0.4 1.5-1 0.4-0.8 0.1-1.7-0.7-2.1z m-12.5-15.2c-0.4 0-0.8-0.4-0.8-0.8s0.4-0.9 0.8-0.9 0.9 0.4 0.9 0.9-0.4 0.8-0.9 0.8z' })
        )
    );
};

exports.default = TiPlane;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/plane.js
// module id = 3688
// module chunks = 0